
<div v-show="errorMessage && errorMessage.length" class="InputErrorMessage">
  {{ errorMessage }}
</div>
